import * as React from "react";
import ChatAppBar from "components/header/chatroomappbar";
import "./styles.scss";
import {connect} from "react-redux";
import Login from "login";
import ChatRoom from "components/chatroom";
import {IReduxState} from "reducers";
import {withRouter} from "react-router";
import {initializeGA} from "analytics/googleAnalyics";
interface  IProps {
  auth: any;
  routes: any;
}
initializeGA();

interface IConnectProps {
  router: any;
}
type FinalProps = IProps & IConnectProps;

function ChatApp(props: FinalProps) {
    return (
        <div className="app" style={{height: "100%"}}>
            <div className="app-bar">
                <ChatAppBar/>
            </div>
            <div className="app-children" style={{height: "100%"}}>
                {props.auth ? <ChatRoom/> : <Login/>}
            </div>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IProps => {
  const auth = state.login.auth ? state.login.auth : null;
  const query = state.router.location.query ? state.router.location.query : null;
  return {
    auth,
    routes: state.router.routes,
  };
};

export default connect<IProps, {}, {}>(mapStateToProps)(withRouter(ChatApp));
